import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'tech-modalservicedisabled',
  templateUrl: './modalservicedisabled.component.html',
  styleUrls: ['./modalservicedisabled.component.scss']
})

export class ModalservicedisabledComponent implements OnInit {
  public item: any;
  public SectionsToComplete:any;
  public Conflict: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialogRef: MatDialogRef<ModalservicedisabledComponent>
  ) {
    this.item = dataDialog.item;
  }

  ngOnInit(): void {
    /*
    var palabras:String[];
     palabras = this.item.SectionsToComplete.split('|');
     this.SectionsToComplete = palabras;
     this.SectionsToComplete = ''

    for ( let itemSplit= 0; itemSplit < palabras.length; itemSplit++) {
      this.SectionsToComplete += '<span>'+ '- ' + palabras[itemSplit] + '</span></br>';
    }
*/
    this.Conflict = this.item.Conflict;
    this.SectionsToComplete = '';
    this.item.SectionsToComplete.forEach((element) => {
         this.SectionsToComplete += '<span>'+ '- '+ element.Name + '</span></br>';
    });

  }

  onClose(e) {
  }
}
